import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const dashboardLoaderSlice = createSlice({
    name: "isDashboardLoading",
    initialState: { value: true },
    reducers: {
        setDashboardLoader: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

export const { setDashboardLoader } = dashboardLoaderSlice.actions;
export default dashboardLoaderSlice.reducer;
